import { render } from "./PlayoutRetainContents.vue?vue&type=template&id=f43f1b3c"
import script from "./PlayoutRetainContents.vue?vue&type=script&setup=true&lang=js"
export * from "./PlayoutRetainContents.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/TVPlayout/PlayoutRetainContents.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f43f1b3c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f43f1b3c', __exports__)) {
    api.reload('f43f1b3c', __exports__)
  }
  
  module.hot.accept("./PlayoutRetainContents.vue?vue&type=template&id=f43f1b3c", () => {
    api.rerender('f43f1b3c', render)
  })

}


export default __exports__